import {create} from 'zustand';
import {galleryApi} from '../services/api/galleryApi';

export const useGalleryStore = create((set, get) => ({
  folders: [],
  images: [],
  isLoading: false,
  pagination: {page: 0, size: 20, totalElements: 0, totalPages: 0, last: true},

  fetchFolders: async () => {
    set({isLoading: true});
    try {
      const response = await galleryApi.listFolders();
      set({folders: response.data.data || []});
    } finally {
      set({isLoading: false});
    }
  },

  createFolder: async name => {
    const response = await galleryApi.createFolder(name);
    const newFolder = response.data.data;
    set(state => ({folders: [...state.folders, newFolder]}));
    return newFolder;
  },

  deleteFolder: async id => {
    await galleryApi.deleteFolder(id);
    set(state => ({folders: state.folders.filter(f => f.id !== id)}));
  },

  fetchImages: async (folderId, page = 0) => {
    set({isLoading: true});
    try {
      const response = await galleryApi.listImages(folderId, {page, size: 20});
      const data = response.data.data;
      set(state => ({
        images: page === 0 ? data.content : [...state.images, ...data.content],
        pagination: {
          page: data.page,
          size: data.size,
          totalElements: data.totalElements,
          totalPages: data.totalPages,
          last: data.last,
        },
      }));
    } finally {
      set({isLoading: false});
    }
  },

  uploadImages: async (folderId, imageAssets) => {
    const response = await galleryApi.uploadImages(folderId, imageAssets);
    const newImages = response.data.data || [];
    set(state => ({images: [...state.images, ...newImages]}));
    return newImages;
  },

  deleteImage: async id => {
    await galleryApi.deleteImage(id);
    set(state => ({images: state.images.filter(img => img.id !== id)}));
  },

  toggleFavorite: async (id, isFavorite) => {
    const response = await galleryApi.toggleFavorite(id, isFavorite);
    const updated = response.data.data;
    set(state => ({
      images: state.images.map(img => (img.id === id ? updated : img)),
    }));
  },

  clearImages: () => set({images: [], pagination: {page: 0, size: 20, totalElements: 0, totalPages: 0, last: true}}),
}));
